import { ApplicationRef, Injectable, OnInit } from '@angular/core'
import { Location } from '@angular/common'
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http'
import { Router } from '@angular/router'
import { catchError, finalize } from 'rxjs/operators'
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar'
import { Observable, throwError } from 'rxjs'
import { AuthService } from '../services/auth.service'

declare var $: any

declare global {
  interface Document {
    documentMode?: any;
  }
}

class RequestOptions {
  body?: any
  observe?: 'body'
  headers?: HttpHeaders
  params?:
    | HttpParams
    | {
      [param: string]:
      | string
      | number
      | boolean
      | ReadonlyArray<string | number | boolean>
    }
  responseType?: 'json' | 'arraybuffer' | 'blob' = 'json'
}

@Injectable()
export class SecureHttp implements OnInit {
  accessToken: string | null = null
  snackBarConfig: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'top',
    duration: 5000
  };

  constructor(
    private _app: ApplicationRef,
    private _http: HttpClient,
    private _location: Location,
    private _router: Router,
    private _snackbar: MatSnackBar,
    private _authService: AuthService,
  ) {
    this.accessToken = this._authService.getToken();
    if (this.accessToken) {
      let headers = new HttpHeaders()
      headers = headers.set('Authorization', `Bearer ${this.accessToken}`)
    }
  }

  ngOnInit() {
    this.accessToken = this._authService.getToken();
    if (this.accessToken) {
      let headers = new HttpHeaders()
      headers = headers.set('Authorization', `Bearer ${this.accessToken}`)
    }
  }

  checkAuthToken() {
    var tokenExists: boolean = false

    if (this.accessToken) {
      tokenExists = true
    }
    return tokenExists
  }

  request(
    method: string,
    url: string,
    options?: RequestOptions
  ): Observable<any> {
    this.accessToken = this._authService.getToken();
    if (this.accessToken) {
      let headers = new HttpHeaders()
      headers = headers.set('Authorization', `Bearer ${this.accessToken}`)
    }
    if (!this.accessToken) {
      this._snackbar.open('You must have a valid token to access', 'Close', this.snackBarConfig)
      this._router.navigate(['/login']);
    }

    options = options || {}

    options.headers = options.headers || new HttpHeaders()
    options.headers = options.headers.set('Authorization', `Bearer ${this.accessToken}`)
    options.headers = options.headers.set('Cache-Control', 'no-cache')

    options.params = options.params || new HttpParams()

    return this._http
      .request(method, url, options as any)
      .pipe(catchError(this.catchAuthError(this)))
  }

  get(url: string, options?: RequestOptions): Observable<any> {
    return this.request('GET', url, options).pipe(
      finalize(() => {
        // IE hack
        if (!!document['documentMode']) {
          setTimeout(() => {
            this._app.tick()
          }, 2000)
        }
      })
    )
  }

  post(url: string, body: any, options?: RequestOptions): Observable<any> {
    if (!options && Object.keys(body).length > 0) {
      options = {}
      options.body = body
    }
    if (
      options &&
      body &&
      Object.keys(options).length > 0 &&
      Object.keys(body).length > 0
    ) {
      options.body = body
    }

    return this.request('POST', url, options).pipe(
      finalize(() => {
        // IE hack
        if (!!document['documentMode']) {
          setTimeout(() => {
            this._app.tick()
          }, 2000)
        }
      })
    )
  }

  put(url: string, body: any, options?: RequestOptions): Observable<any> {
    if (!options && Object.keys(body).length > 0) {
      options = {}
      options.body = body
    }
    if (
      options &&
      Object.keys(options).length > 0 &&
      Object.keys(body).length > 0
    ) {
      options.body = body
    }
    return this.request('PUT', url, options).pipe(
      finalize(() => {
        // IE hack
        if (!!document['documentMode']) {
          setTimeout(() => {
            this._app.tick()
          }, 2000)
        }
      })
    )
  }

  delete(url: string, options?: RequestOptions): Observable<any> {
    return this.request('DELETE', url, options).pipe(
      finalize(() => {
        // IE hack
        if (!!document['documentMode']) {
          setTimeout(() => {
            this._app.tick()
          }, 2000)
        }
      })
    )
  }

  private catchAuthError(self: SecureHttp) {
    // we have to pass _httpService's own instance here as `self`
    return (res: HttpErrorResponse) => {
      if (!res.url || res.url.indexOf('api/users/self') > 0) {
        return throwError(() => res)
      }

      if (res.status == 400 && res) {
        // if (typeof (res) === 'string') {
        //     const msg = res.error.startsWith('{') ? JSON.parse(res)[''][0] : res;
        //     this.toast.error(msg, 'Validation Error');
        // } else {

        let errors = res.error

        this._snackbar.open('Error during auth', 'close', this.snackBarConfig)
      }

      if (res.status === 401 || res.status === 403) {
        // if not authenticated
        this._snackbar.open(
          'You must be logged in to complete this action',
          'Not Logged In', this.snackBarConfig
        )

        this._router.navigate(['/login']);
      }

      return throwError(() => (res));
    }
  }
}
